import React from 'react';
import { Navigation } from '../components/Navigation';
import { SearchOrDeriveSection } from '../components/why/SearchOrDeriveSection';
import { MathClosureSection } from '../components/why/MathClosureSection';
import { MethodSection } from '../components/why/MethodSection';
import { EnablesSection } from '../components/why/EnablesSection';
export function WhyWhiteBoxPage() {
  return <div style={{
    width: '100%',
    backgroundColor: 'var(--black)',
    minHeight: '100vh'
  }} data-id="element-530">
      <Navigation data-id="element-531" />
      <main style={{
      paddingTop: '64px'
    }} data-id="element-532">
        {/* Section 1 — Search or Derive */}
        <SearchOrDeriveSection data-id="element-533" />

        {/* Separator */}
        <div style={{
        width: '100%',
        height: '1px',
        backgroundColor: 'rgba(255,255,255,0.05)'
      }} data-id="element-534" />

        {/* Section 2 — Why Industry Needs Mathematical Closure */}
        <MathClosureSection data-id="element-535" />

        {/* Separator */}
        <div style={{
        width: '100%',
        height: '1px',
        backgroundColor: 'rgba(255,255,255,0.05)'
      }} data-id="element-536" />

        {/* Section 3 — The White Box Method */}
        <MethodSection data-id="element-537" />

        {/* Separator */}
        <div style={{
        width: '100%',
        height: '1px',
        backgroundColor: 'rgba(255,255,255,0.05)'
      }} data-id="element-538" />

        {/* Section 4 — What This Enables */}
        <EnablesSection data-id="element-539" />
      </main>
    </div>;
}